import React, { useState, useEffect } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';  // Only imported once
import Approach from './components/Approach';
import Industries from './components/Industries';
import ClientBenefits from './components/ClientBenefits';
import EngineeringStack from './components/EngineeringStack'; 
import Contact from './components/Contact';
import Footer from './components/Footer';
import ServiceModal from './components/ServiceModal';

function App() {
  const [selectedService, setSelectedService] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = (serviceId) => {
    setSelectedService(serviceId);
    setIsModalOpen(true);
    document.body.style.overflow = 'hidden';
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedService(null);
    document.body.style.overflow = 'unset';
  };

  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === 'Escape') {
        closeModal();
      }
    };
    window.addEventListener('keydown', handleEsc);
    return () => window.removeEventListener('keydown', handleEsc);
  }, []);

  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />
      <main>
        <Hero />
        <About /> 
        <Services openModal={openModal} />  {/* Services component - shows 6 service cards */}
        <Approach />
        <Industries />                       {/* Industries component - shows industries, not services */}
        <EngineeringStack /> 
        <ClientBenefits />
        <Contact />
      </main>
      <Footer />
      
      {isModalOpen && (
        <ServiceModal 
          serviceId={selectedService} 
          closeModal={closeModal}
        />
      )}
    </div>
  );
}

export default App;